<template>
    <tr>
        <td>
            <checkbox-input
                v-model="selected"
                name="addresses[]"
                :value="address.id"
                :disabled="disabled"
                @toggle="toggleItem"
            />
        </td>
        <td>
            <a :href="addressRoute">
                {{ address.full_address_with_apartment_number }}
            </a>
        </td>
        <td>
            {{ address.sales_project.name }}
        </td>
    </tr>
</template>
<script>
    export default {
        props: {
            address: {
                required: true,
                type: Object,
            },
            deliveryProject: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                selected: false,
            };
        },
        computed: {
            disabled() {
                return this.address.group_id !== null;
            },
            addressRoute() {
                if (this.address.delivery_project_id) {
                    return route('admin.delivery-projects.addresses.show', [
                        this.address.delivery_project_id,
                        this.address.id,
                    ]);
                }

                return route('admin.sales-projects.addresses.show', [
                    this.address.sales_project_id,
                    this.address.id,
                ]);
            },
        },
        created() {
            EventBus.$on('all-addresses-toggled', (toggled) => {
                if (! this.disabled) {
                    this.selected = toggled;
                    this.toggleItem();
                }
            });
        },
        methods: {
            toggleItem() {
                this.$emit('toggleAddressSelected', this.address, this.selected);
            },
        },
    };
</script>
